import { styled } from "@mui/material";
import Button from "@mui/material/Button";
import LinkButton from "../../../components/link-button/link-button";
import { routeMapping } from "../../../route.config";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

const PopularFeatures = ({ className }: IWithClassName) => (
    <div className={className}>
        <h2 className="popular-features-title">POPULAR FEATURES</h2>
        <div className="popular-features">
            <Button
                LinkComponent={LinkButton}
                href={routeMapping.listBuilder.path}
                className="custom-list-builder popular-features-item"
                variant="contained"
            >
                Custom List Builder
            </Button>
            <Button
                LinkComponent={LinkButton}
                href={routeMapping.dataBrowser.path}
                className="data-browser popular-features-item"
                variant="contained"
            >
                Data Browser
            </Button>
            <Button
                LinkComponent={LinkButton}
                href={routeMapping.userPreferences.path}
                className="user-preferences popular-features-item"
                variant="contained"
            >
                User Preferences
            </Button>
        </div>
    </div>
);

export default styled(PopularFeatures)(({ theme }: IWithThemeProps) => ({
    marginTop: theme?.spacing(7),
    ".popular-features-title": {
        color: theme?.palette.text.primary,
        fontSize: 20,
        marginBottom: theme?.spacing(2),
    },
    ".popular-features": {
        display: "flex",
        justifyContent: "space-between",
    },
    ".popular-features-item": {
        height: 299,
        width: 311,
        borderRadius: theme?.spacing(2.5),
        color: theme?.palette.text.primary,
        fontSize: 28,
        fontWeight: 700,
        textTransform: "none",
    },
    ".custom-list-builder": {
        backgroundImage: "url(/assets/custom-list-builder-bg.png)",
    },
    ".data-browser": {
        backgroundImage: "url(/assets/data-browser-bg.png)",
    },
    ".user-preferences": {
        backgroundImage: "url(/assets/user-preferences-bg.png)",
    },
}));
